import { render } from "./RegistrationDemographic.vue?vue&type=template&id=4c6595b2"
import script from "./RegistrationDemographic.vue?vue&type=script&lang=js"
export * from "./RegistrationDemographic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\HOSAM\\Desktop\\LIBYA\\qr-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__